import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import SignInFormContainer from '../signin/SignInFormContainer'
import SignInWithGoogle from '../signin/SignInWithGoogle'
import BlueButton from '../signin/BlueButton'
import Separator from '../signin/Separator'
import FancyInput from '../signin/FancyInput'
import FormBlock from '../signin/FormBlock'
import { sendPasswordResetEmail } from 'controllers/auth'
import Text from 'components/common/Text'

const ForgotPasswordContainer = styled.div`
  cursor: pointer;
  font-size: 15px;
`

function validateEmail (email) {
  const re = new RegExp('[^@]+@[^@]+\\.[^@]+')
  return re.test(email)
}

class SignInForm extends Component {

  handleSignIn = () => {
    let formIsValid = true
    const inputs = [this.emailInput, this.passwordInput]

    inputs.forEach((input) => {
      if (!input.state.valid) {
        formIsValid = false
        return
      }
      if (input.value() === '') {
        formIsValid = false
        input.setupValidState({
          valid: false,
          invalidMessage: 'This field is required'
        })
      }
    })

    if (formIsValid) {
      this.props.handleSignIn({
        email: this.emailInput.value(),
        password: this.passwordInput.value(),
      })
    }
  }

  forgotPassword = () => {
    const input = this.emailInput
    const v = input.value()
    if (v === '') {
      input.setupValidState({
        valid: false,
        invalidMessage: 'This field is required'
      })
    } else if (validateEmail(v)) {
      this.props.dispatch(sendPasswordResetEmail(v))
    }
  }

  render () {
    return <SignInFormContainer>
      <FormBlock marginTop={5}>
        <SignInWithGoogle onClick={this.props.handleGoogleSignIn} />
      </FormBlock>
      <FormBlock marginTop={25} marginBottom={17}>
        <Separator />
      </FormBlock>
      <FormBlock marginTop={16} marginBottom={16}>
        <FancyInput
          placeholder='Email'
          ref={(input) => { this.emailInput = input }}
          onBlurValidation={value => validateEmail(value)}
          onBlurValidationMessage='That’s not a valid email address'
        />
      </FormBlock>
      <FormBlock marginTop={16} marginBottom={16}>
        <FancyInput
          placeholder='Password'
          type='password'
          ref={(input) => { this.passwordInput = input }}
        />
      </FormBlock>
      <FormBlock
        marginTop={38}
        marginBottom={5}
        paddingLeft={2}
        justifyContent='space-between'
      >
        <ForgotPasswordContainer onClick={this.forgotPassword}>
          <Text size='medium'>Forgot Password?</Text>
        </ForgotPasswordContainer>

        <BlueButton
          text='Sign in'
          width={82}
          height={32}
          onClick={this.handleSignIn}
        />
      </FormBlock>
    </SignInFormContainer>
  }
}

SignInForm.propTypes = {
  handleSignIn: PropTypes.func.isRequired,
  handleGoogleSignIn: PropTypes.func.isRequired,
}

export default connect()(SignInForm)



// WEBPACK FOOTER //
// ./src/components/signin/SignInForm.js